export const AUTH_ROUTES = {
  AUTH: '/auth',
  SIGN_IN: '/auth/sign-in',
  SIGN_UP: '/auth/sign-up'
}

export const APP_ROUTES = {
  HOME: '/',
  PRODUCTS: '/products',
  PRODUCT_DETAIL: '/products/:id',
  DYNAMIC_FORM: '/products/new',
  WHITELIST: '/whitelist'
}
